import React from "react";
import AddDocument from "./AddDocument";
import Document from "./Document";
import DocumentTitle from "./DocumentTitle";
import DocumentUploadButton from "../../../overview/previewDocuments/upload/DocumentUploadButton";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { useEffect } from "react";
import * as Validator from "../../previewDocuments/requestPreviewDocumentsValidator";
import DocumentUploadProgress from "../../previewDocuments/upload/DocumentUploadProgress";
import { subscribe, unsubscribe } from "../../../../../eventBus";

export const UPLOAD_STATUS = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  ERROR: 2,
  TIMEOUT: 3,
  SUCCESS: 4,
};

export const statusColor = (status) => {
  switch (status) {
    case UPLOAD_STATUS.ERROR:
    case UPLOAD_STATUS.TIMEOUT:
      return "red";
    case UPLOAD_STATUS.IN_PROGRESS:
      return "yellow";
    case UPLOAD_STATUS.SUCCESS:
      return "green";
    default:
      return "grey";
  }
};

function DocumentUpload({
  isAdditional,
  disabled,
  dispatchUpdateAction,
  documents,
  attachments,
  minDocumentsAttached,
  acceptDocumentTypes,
  maxDocumentSizeInMb,
  className = "",
  reds = false,
  uploadUrl = `${process.env.REACT_APP_GATEWAY_URL}/upload`,
  formDataAsJson,
  setSelected,
}) {
  const { t } = useTranslation();
  const validate = useCallback(() => {
    return {
      valid: Validator.minDocumentsAttached(documents, minDocumentsAttached),
      message: t("requests.submission.upload.minDocumentsAttached"),
    };
  }, [minDocumentsAttached, documents, t]);

  useEffect(() => {
    const subscriber = subscribe("validate-document-upload", () => {
      return validate();
    });
    return () => unsubscribe(subscriber);
  }, [validate]);
  return (
    <div className={`${className}`}>
      {documents.map((doc, index) => (
        <Document
          key={`doc${index}`}
          index={index}
          uploadStatus={doc.uploadStatus}
          renderDocumentTitle={() => (
            <DocumentTitle
              disabled={disabled}
              index={index}
              required={doc.required}
              label={doc.label}
              link={doc.link}
              dispatchUpdateAction={dispatchUpdateAction}
              documents={documents}
              color={doc.color}
              isAdditional={isAdditional}
              /* file={doc.file !== null ? true : false} */
            />
          )}
          renderDocumentUploadProgress={() => (
            <DocumentUploadProgress
              id={index}
              doc={doc}
              dispatchUpdateAction={dispatchUpdateAction}
              color={doc.color}
              setSelected={setSelected}
            />
          )}
          renderDocumentUploadButton={() => (
            <DocumentUploadButton
              id={index}
              doc={doc}
              uploadUrl={uploadUrl}
              maxDocumentSizeInMb={maxDocumentSizeInMb}
              acceptDocumentTypes={acceptDocumentTypes}
              dispatchUpdateAction={dispatchUpdateAction}
              formDataAsJson={formDataAsJson}
              setSelected={setSelected}
            />
          )}
        />
      ))}
      {reds === true && !disabled ? (
        <div>
          <AddDocument
            disabled={disabled}
            documents={documents}
            dispatchUpdateAction={dispatchUpdateAction}
            title={t("requests.reviewDocuments.supplements.addDocument")}
            color={isAdditional ? "red" : "grey"}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default DocumentUpload;
